import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TTServiceCardProps {
  icon: LucideIcon;
  flag: string;
  title: string;
  features: string[];
  color: 'red' | 'black' | 'white';
  ttdPrice: string;
  onGetFreeAccess: () => void;
}

const TTServiceCard = ({ 
  icon: Icon, 
  flag, 
  title, 
  features, 
  color, 
  ttdPrice,
  onGetFreeAccess 
}: TTServiceCardProps) => {
  const colorClasses = {
    red: {
      card: "bg-gradient-to-br from-red-50 to-red-100 border-red-200 hover:border-red-300",
      icon: "text-red-600 bg-red-100",
      price: "text-red-700 bg-red-50 border-red-200",
      button: "bg-red-600 hover:bg-red-700 text-white"
    },
    black: {
      card: "bg-gradient-to-br from-gray-50 to-gray-100 border-gray-300 hover:border-gray-400",
      icon: "text-gray-800 bg-gray-100",
      price: "text-gray-800 bg-gray-50 border-gray-300",
      button: "bg-gray-800 hover:bg-gray-900 text-white"
    },
    white: {
      card: "bg-gradient-to-br from-white to-gray-50 border-gray-200 hover:border-gray-300 shadow-lg",
      icon: "text-gray-700 bg-white border border-gray-200",
      price: "text-gray-700 bg-white border-gray-200",
      button: "bg-white hover:bg-gray-50 text-gray-800 border border-gray-300"
    }
  };

  const classes = colorClasses[color];

  return (
    <div className={`rounded-xl p-6 border-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${classes.card}`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${classes.icon}`}>
          <Icon className="w-8 h-8" />
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-2xl">{flag}</span>
        </div>
      </div>
      
      <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
      
      {/* TTD Price Display */}
      <div className={`inline-flex items-center px-3 py-1 rounded-lg text-sm font-bold mb-3 border ${classes.price}`}>
        🇹🇹 {ttdPrice}
      </div>
      
      <ul className="space-y-2 mb-6">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <span className="text-green-500 mr-2 mt-1 flex-shrink-0">✓</span>
            <span className="text-gray-700 text-sm">{feature}</span>
          </li>
        ))}
      </ul>
      
      <div className="space-y-3">
        <Button 
          onClick={onGetFreeAccess}
          className={`w-full transition-all duration-300 ${classes.button}`}
        >
          Get Free Access
        </Button>
        
        <Button 
          onClick={() => window.location.href = '/consultation'}
          variant="outline"
          className="w-full border-2 border-red-600 text-red-600 hover:bg-red-50 font-bold transition-all duration-300"
        >
          Purchase Now
        </Button>
      </div>
    </div>
  );
};

export default TTServiceCard;